// src/components/ui/illustrations/ActivityFigure.tsx
// A recognisable pose for a physical-activity level (Phase 3's
// pictorial-choice) — see docs/HMS_V4_PRECONSULT_REDESIGN_PLAN.md Phase 0.
import { ILLUSTRATION_SIZE_PX, TONE_INK_VAR, type IllustrationSize, type IllustrationTone } from './PlateFill';

export type ActivityPose = 'walking' | 'lifting' | 'sitting';

const POSE: Record<ActivityPose, { headX: number; headY: number; body: string }> = {
  walking: { headX: 13, headY: 4, body: 'M11 22l2-6 3-3-1-5-4 2-2 3M13 13l3 4 1 5' },
  lifting: { headX: 12, headY: 4, body: 'M12 7v6M8 9h8M9 22l3-9 3 9M6 12h12' },
  sitting: { headX: 11, headY: 4, body: 'M11 7v6h5M11 13H7v7M16 13v7' },
};

export interface ActivityFigureProps {
  pose: ActivityPose;
  tone: IllustrationTone;
  size?: IllustrationSize;
  title?: string;
}

export function ActivityFigure({ pose, tone, size = 'md', title }: ActivityFigureProps) {
  const px = ILLUSTRATION_SIZE_PX[size];
  const color = TONE_INK_VAR[tone];
  const p = POSE[pose];
  return (
    <svg
      width={px} height={px} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth={1.7} strokeLinecap="round"
      aria-hidden="true" focusable="false"
    >
      {title && <title>{title}</title>}
      <circle cx={p.headX} cy={p.headY} r="2" fill={color} stroke="none" />
      <path d={p.body} />
    </svg>
  );
}
